import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';
import creatorsUpdaters from '@/api/updaters/creators';
import {recruitmentsQueryKey} from '@/hooks/queries/use-recruitments-query';

export type RecruitToCrmProfileResultItem = {
  profileId: string;
  success: boolean;
  recruitmentId?: string;
  status?: string;
  errorCode?: string;
};

export type RecruitToCrmEmailResultItem = {
  email: string;
  success: boolean;
  recruitmentId?: string;
  status?: string;
  errorCode?: string;
};

export type RecruitToCrmResponse = {
  results: {
    profiles: RecruitToCrmProfileResultItem[];
    emails: RecruitToCrmEmailResultItem[];
  };
  summary: {
    total: number;
    succeeded: number;
    failed: number;
  };
};

function useRecruitToCrm(): UseMutationResult<
  RecruitToCrmResponse,
  Error,
  {agencyId: string; creatorIds?: string[]; emails?: string[]}
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['creators', 'recruitToCrm'],
    mutationFn: creatorsUpdaters.recruitToCrm,
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: [recruitmentsQueryKey]});
    },
  });
}

export default useRecruitToCrm;
